var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-3 list",attrs:{"elevation":"0","height":"auto"}},[_vm._l((_vm.histories),function(history){return [_c('git-history-card',{key:history.id,staticClass:"mt-2 mb-2",attrs:{"history":history}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }